import { BaSeLoading, BaSeParagraph, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import ProgressBar from '../../../components/progress-bar/progress-bar';
import { useReport } from '../hook/useReport';

function EntrepreneurialProfile() {
  const { getRouteParam } = Sebrae.useSebraeRouter();
  const { getStepData, laoding } = useReport();
  const [response, setResponse] = React.useState();
  const [erro, setErro] = React.useState();

  React.useEffect(() => {
    getStepData({ cpf: getRouteParam('cpf'), step: 'PERFIL_EMPREENDEDOR' })
      .then((response) => {
        setResponse(response);
      })
      .catch((error) => {
        setErro(error);
        console.log('deu erro', error);
      });
  }, [getRouteParam, getStepData]);

  if (laoding) {
    return (
      <BaSeLoading
        backgroundColor="#fff"
        description=""
        lightMode="default"
        shadowLevel={0}
        spinnerColor=""
        spinnerSize={24}
        text="Carregando…"
        textColor=""
      />
    );
  }

  if (!response?.showStep) {
    return <> </>;
  }

  return (
    <div>
      <BaSeParagraph color={BaSeTheme.colors.gestao.cinza10} isBold>
        PERFIL EMPREENDEDOR
      </BaSeParagraph>
      {erro && 'Erro ao carregar dados da sessão PERFIL EMPREENDEDOR!'}

      {response?.data?.map((item) => (
        <ProgressBar
          max={item?.max}
          value={item?.value}
          colorTitle="#636363"
          title={item?.title}
          withDetailDescription={true}
          titleDetailDescription="O que significa esse comportamento empreendedor?"
          detailDescription={item?.detailsDescription}
        />
      ))}
    </div>
  );
}

export default EntrepreneurialProfile;
